<template>
  <v-layout wrap v-if="riwayatKehadiran">
    <v-flex xs12>
      <m-card title="Detail Presensi">
        <v-layout wrap>
          <v-flex xs12 sm7 md8>
            <v-list>
              <v-subheader class="title green--text">Identitas</v-subheader>
              <v-divider></v-divider>
              <m-list-tile-info label="No. Reg" :value="riwayatKehadiran.presensi_id"/>
              <m-list-tile-info label="Nama" :value="riwayatKehadiran.nama"/>
              <m-list-tile-info label="Surel" :value="riwayatKehadiran.email"/>
              <v-subheader class="title green--text">Alamat</v-subheader>
              <v-divider></v-divider>
              <m-list-tile-info label="Alamat" :value="riwayatKehadiran.alamat"/>
            </v-list>
          </v-flex>
        </v-layout>
      </m-card>
    </v-flex>
  </v-layout>
</template>
<script>
export default {
  components: {},
  data() {
    return {
      riwayatKehadiran: null
    };
  },
  computed: {},
  activated() {
    this.load();
  },
  methods: {
    load() {
      this.$store
        .dispatch("riwayatKehadiran/detail", this.$route.params.presensi_id)
        .then(res => {
          this.page = res.data;
          this.riwayatKehadiran = res.data;
        })
        .catch(e => e);
    },
    close() {
      this.$router.push({
        name: "riwayatKehadiran"
      });
    }
  }
};
</script>
